var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "footer-address white--text" },
    [
      _c(
        "v-row",
        [
          _c("v-col", { attrs: { cols: "12", sm: "5" } }, [
            _c("p", { staticClass: "mb-0" }, [
              _vm._v("Botanická zahrada Liberec – LK")
            ]),
            _c("p", { staticClass: "mb-0" }, [
              _vm._v("příspěvková organizace")
            ]),
            _c("p", { staticClass: "mb-0" }, [_vm._v("Purkyňova 630/1")]),
            _c("p", { staticClass: "mb-0" }, [_vm._v("460 01 Liberec")])
          ]),
          _c("v-col", { attrs: { cols: "12", sm: "7" } }, [
            _c("p", { staticClass: "mb-0" }, [_vm._v("Otevírací hodiny:")]),
            _c("p", { staticClass: "mb-0" }, [
              _vm._v("Po – Ne: 9 – 16 hod. během zimního času")
            ]),
            _c("p", { staticClass: "mb-0" }, [
              _vm._v("8 – 18 hod. během letního času")
            ]),
            _c("p", { staticClass: "mb-0" }, [
              _vm._v("Dne 1. ledna je výjimka: otevřeno 10 – 16 hod.")
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }